/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchInviteJobResponse
 */
export interface BatchInviteJobResponse {
    /**
     * A job unique identifier.
     * @type {string}
     * @memberof BatchInviteJobResponse
     */
    jobId: string;
}

export function BatchInviteJobResponseFromJSON(json: any): BatchInviteJobResponse {
    return BatchInviteJobResponseFromJSONTyped(json, false);
}

export function BatchInviteJobResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchInviteJobResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jobId': json['jobId'],
    };
}

export function BatchInviteJobResponseToJSON(value?: BatchInviteJobResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'jobId': value.jobId,
    };
}

